//  ####               ####   ####  #####     #####   ##      ##
//  ##  ##            ##     ##     ##  ##   ##   ##  ##      ##
//  ##  ##  ########   ###   ##     #####    ##   ##  ##      ##
//  ##  ##               ##  ##     ##  ##   ##   ##  ##      ##
//  ####              ####    ####  ##   ##   #####   ######  ######
/*
マウスドラッグでスクロール可能にする
<div class="js-dragScroll">
テキストテキスト
</div>
*/
function dragScroll(targetName) {
  const targetList = document.querySelectorAll(targetName)
  if (!targetList[0]) {
    return
  }
  let target
  for (let i = 0; i < targetList.length; i++) {
    targetList[i].addEventListener('mousedown', function (event) {
      event.preventDefault()

      target = targetList[i]
      target.dataset.down = '1'
      target.dataset.move = '0'
      target.dataset.x = event.clientX
      target.dataset.y = event.clientY
      target.dataset.scrollLeft = target.scrollLeft
      target.dataset.scrollTop = target.scrollTop
      event.stopPropagation()
    })
    targetList[i].addEventListener('click', function (event) {
      if (!targetList[i].dataset || targetList[i].dataset.move !== '1') {
        return
      }
      event.stopPropagation()
    })
  }
  document.addEventListener('mousemove', function (event) {
    if (!target || target.dataset.down !== '1') {
      return
    }
    event.preventDefault()

    let moveX = parseInt(target.dataset.x) - event.clientX
    let moveY = parseInt(target.dataset.y) - event.clientY
    if (moveX !== 0 || moveY !== 0) {
      target.dataset.move = '1'
    } else {
      return
    }
    target.scrollLeft = parseInt(target.dataset.scrollLeft) + moveX
    target.scrollTop = parseInt(target.dataset.scrollTop) + moveY
    event.stopPropagation()
  })
  document.addEventListener('mouseup', function (event) {
    if (!target || target.dataset.down !== '1') {
      return
    }
    target.dataset.down = '0'
    event.stopPropagation()
  })
}
dragScroll('.js-dragScroll')
